(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './utilities'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./utilities'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.utilities);
    global.isEmail = mod.exports;
  }
})(this, function (exports, _utilities) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  }); // Borrowed from http://emailregex.com/
  // This is the same email regex as browsers use when type="email"

  var EMAIL_REGEXP = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  exports.default = function (config) {
    return function (value) {
      if ((0, _utilities.isString)(value)) {
        return !EMAIL_REGEXP.test(value) ? config.message : null;
      }

      return (0, _utilities.isInvalidType)(value, [_utilities.Types.string]);
    };
  };
});